import {loadReports, loadFile, loadFiles} from "@/api/prognozweb/reports.api";
import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);

const state = {
  reports: [],
  files: [],
  file: [],
  notification: [],
  copy: [],
}
const mutations = {
  setReports(state, data) {
    state.reports = data ? data : [];
  },
  setFile(state, data) {
    state.file = data ? data : [];
  },
  setFiles(state, data) {
    state.files = data ? data : [];
  },
  setNotification(state, data) {
    state.notification = data ? data : [];
  },
  setReportsCopy(state, data) {
    state.copy = data ? data : [];
  },
}
const actions = {
  async loadReports({commit}){
    try{
      const response = await loadReports();
      commit('setReports', response.data);
    }catch(error){
      Vue.$toast.open({
        message: `Não foi possível carregar as informações dos relatórios.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setReports', undefined);
    }
  },
  async loadFile( {commit}, payload ) {
    try {
      const response = await loadFile({ ...payload });
      commit('setFile', response);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar o arquivo.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setFile', undefined);
    }
  },
  async loadFiles( {commit}, payload ) {
    try {
      const response = await loadFiles({ ...payload });
      commit('setFiles', response);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar os arquivos.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setFiles', undefined);
    }
  }
}
const getters = {
  reports: (state) => state.reports,
  file: (state) => state.file,
  files: (state) => state.files,
  notification: (state) => state.notification,
  copy: (state) => state.copy,
}
export default {
  state,
  mutations,
  actions,
  getters
}
